export default {
  title: 'Client Portal',
  titlePrefix: '',
  ErrorTitle: 'Technical error',
  ErrorMessage: 'An error has occured. We apologize for the inconvenience.',
  ErrorRetryButton: 'Retry',
  NotFoundTitle: 'Page not found',
  NotFoundMessage: 'Sorry, the page may have been moved or deleted.',
  NotFoundBackButton: 'Back',
  copyright: `Investia Financial Services Inc. is a wholly-owned subsidiary of Industrial Alliance Insurance and Financial Services Inc., a life and health insurance company <1></1> which operates under the trade name iA Financial Group. © ${new Date().getFullYear()} Investia Financial Services - All rights reserved`,
};
